var exports = {
  "e": "CompactCommentInputContainer__rX5WAC",
};

module.exports = exports;
